import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { login } from '../../api/auth';
import { useAuthStore } from '../../store/authStore';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';

export default function Login() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(form);
      const token = res.data.token || res.data.key || res.data.access;
      setAuth(token, res.data.user || null);
      toast.success('Добредојдовте!');
      navigate('/');
    } catch (err) {
      const msg =
        err.response?.data?.non_field_errors?.[0] ||
        err.response?.data?.detail ||
        'Најавата не успеа. Проверете ги вашите податоци.';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-green-100">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8">
        <div className="text-center mb-8">
          <span className="text-4xl">🌱</span>
          <h1 className="mt-2 text-2xl font-bold text-gray-800">AgroPlatform</h1>
          <p className="text-gray-500 text-sm mt-1">Најавете се на вашата сметка</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Корисничко име"
            name="username"
            type="text"
            autoComplete="username"
            value={form.username}
            onChange={handleChange}
            required
            placeholder="вашето_корисничко_име"
          />
          <Input
            label="Лозинка"
            name="password"
            type="password"
            autoComplete="current-password"
            value={form.password}
            onChange={handleChange}
            required
            placeholder="••••••••"
          />
          <Button type="submit" loading={loading} className="w-full mt-2" size="lg">
            Најава
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-gray-500">
          Немате сметка?{' '}
          <Link to="/register" className="text-green-700 font-medium hover:underline">
            Регистрирај се
          </Link>
        </p>
      </div>
    </div>
  );
}
